<template>
  <main class="main main--terms">
    <component
      :is="privacyContent"
      class="group group--indent typeset typeset--terms links"
    />
  </main>
</template>

<script>
// Models
import meta from 'models/meta';
import privacyContent from 'models/content/privacy.md';

// Utils
import { createMeta } from 'utils/meta';

// Export
export default {
  name: 'view-privacy',

  // Meta data
  metaInfo: {
    title: meta.terms.title,
    meta: createMeta(meta.terms.meta),
  },

  // Data
  data() {
    return {
      privacyContent,
    };
  },
};
</script>



// WEBPACK FOOTER //
// Privacy.vue?79dba3f7